import { useMemo } from 'react';
import { provisionWorkloads } from '../utilities/provisionWorkloads';
import { useWorkloads } from './useWorkloads';
export function useProvisionedWorkloads() {
    var allWorkloads = useWorkloads().data;
    return useMemo(function () {
        if (!allWorkloads) {
            return undefined;
        }
        return provisionWorkloads(allWorkloads);
    }, [allWorkloads]);
}
//# sourceMappingURL=useProvisionedWorkloads.js.map